/* =============================================
   SPECTA — Main Theme Script
   ============================================= */

(function () {
  'use strict';

  /* ---------- UTILITIES ---------- */
  var $ = function (s, p) { return (p || document).querySelector(s); };
  var $$ = function (s, p) { return Array.prototype.slice.call((p || document).querySelectorAll(s)); };

  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, a); }, ms);
    };
  }

  /* ---------- SCROLL PROGRESS (GPU-composited via scaleX) ---------- */
  var progress = $('#progress');
  if (progress) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () {
          var h = document.documentElement;
          var pct = h.scrollTop / (h.scrollHeight - h.clientHeight);
          progress.style.transform = 'scaleX(' + Math.min(pct, 1) + ')';
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ---------- NAV HIDE/SHOW ON SCROLL ---------- */
  var nav = $('#nav');
  if (nav) {
    var lastY = 0;
    var scrollTimer;
    var THRESHOLD = 5;

    window.addEventListener('scroll', function () {
      if (scrollTimer) return;
      scrollTimer = requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y > 80) nav.classList.add('sc');
        else nav.classList.remove('sc');
        if (y > lastY + THRESHOLD && y > 160) nav.classList.add('hd');
        else if (y < lastY - THRESHOLD) nav.classList.remove('hd');
        lastY = y;
        scrollTimer = null;
      });
    }, { passive: true });
  }

  /* ---------- MOBILE MENU ---------- */
  var ham = $('#ham');
  var mobNav = $('#mobNav');

  function setMobState(open) {
    if (!ham || !mobNav) return;
    ham.classList.toggle('open', open);
    mobNav.classList.toggle('open', open);
    ham.setAttribute('aria-expanded', String(open));
    mobNav.setAttribute('aria-hidden', String(!open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) trapFocus(mobNav);
    else releaseFocus();
  }

  window.toggleMob = function () { setMobState(!ham.classList.contains('open')); };
  window.closeMob = function () { setMobState(false); };

  /* ---------- SEARCH OVERLAY ---------- */
  var searchOv = $('#searchOv');
  var searchIn = $('#searchIn');
  var searchRes = $('#searchRes');

  window.openSearch = function () {
    if (!searchOv) return;
    searchOv.classList.add('open');
    searchOv.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    trapFocus(searchOv);
    setTimeout(function () { if (searchIn) searchIn.focus(); }, 120);
  };

  window.closeSearch = function () {
    if (!searchOv) return;
    searchOv.classList.remove('open');
    searchOv.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    releaseFocus();
    if (searchIn) searchIn.value = '';
    if (searchRes) searchRes.innerHTML = '';
  };

  window.doSearch = debounce(function () {
    if (!searchIn || !searchRes) return;
    var q = searchIn.value.trim();
    if (q.length < 2) { searchRes.innerHTML = ''; return; }

    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) {
          searchRes.innerHTML = '<div class="si"><span class="sn">No results found</span></div>';
          return;
        }
        searchRes.innerHTML = products.map(function (p) {
          return '<a href="' + p.url + '" class="si" role="option">' +
            '<span class="sn">' + escHtml(p.title) + '</span>' +
            '<span class="sp">' + formatMoney(p.price) + '</span></a>';
        }).join('');
      })
      .catch(function () {
        searchRes.innerHTML = '<div class="si"><span class="sn">Search unavailable</span></div>';
      });
  }, 280);

  /* ---------- ESCAPE KEY ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (searchOv && searchOv.classList.contains('open')) closeSearch();
      else if (cartDraw && cartDraw.classList.contains('open')) closeCart();
      else if (mobNav && mobNav.classList.contains('open')) closeMob();
    }
  });

  /* ---------- CART DRAWER ---------- */
  var cartOv = $('#cartOv');
  var cartDraw = $('#cartDraw');
  var cartItems = $('#cartItems');
  var cartTotal = $('#cartTotal');
  var cartBadge = $('#cartBadge');

  window.openCart = function () {
    if (!cartOv || !cartDraw) return;
    cartOv.classList.add('open');
    cartOv.setAttribute('aria-hidden', 'false');
    cartDraw.classList.add('open');
    cartDraw.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    trapFocus(cartDraw);
    fetchCart();
  };

  window.closeCart = function () {
    if (!cartOv || !cartDraw) return;
    cartOv.classList.remove('open');
    cartOv.setAttribute('aria-hidden', 'true');
    cartDraw.classList.remove('open');
    cartDraw.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    releaseFocus();
  };

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    if (!cartItems) return;
    updateBadge(cart.item_count);

    if (!cart.items.length) {
      cartItems.innerHTML =
        '<div class="cde">' +
        '<svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1" viewBox="0 0 24 24" style="color:var(--g200);margin:0 auto"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg>' +
        '<span>Your bag is empty</span>' +
        '<a href="/collections/all">Browse Collection</a></div>';
      if (cartTotal) cartTotal.textContent = '\u20AC0.00';
      return;
    }

    cartItems.innerHTML = cart.items.map(function (item) {
      return '<div class="cdit">' +
        '<img class="cdimg" src="' + (item.image ? item.image.replace(/(\.[^.]+)$/, '_180x$1') : '') + '" alt="' + escHtml(item.title) + '" loading="lazy">' +
        '<div class="cdif"><h4>' + escHtml(item.product_title) + '</h4>' +
        '<div class="cr"><span class="cp">' + formatMoney(item.final_line_price) + '</span>' +
        (item.variant_title ? '<span class="cs">' + escHtml(item.variant_title) + '</span>' : '') +
        '</div><div class="cda">' +
        '<button onclick="changeQty(\'' + item.key + '\',' + (item.quantity - 1) + ')" aria-label="Decrease quantity">&minus;</button>' +
        '<span aria-label="Quantity">' + item.quantity + '</span>' +
        '<button onclick="changeQty(\'' + item.key + '\',' + (item.quantity + 1) + ')" aria-label="Increase quantity">+</button>' +
        '<button class="cdr" onclick="changeQty(\'' + item.key + '\',0)" aria-label="Remove item">Remove</button>' +
        '</div></div></div>';
    }).join('');

    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
  }

  window.changeQty = function (key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  };

  /* ---------- ADD TO CART ---------- */
  window.addToCart = function (variantId, qty) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        openCart();
        bounceCart();
        showToast('Added to bag');
      })
      .catch(function () { showToast('Could not add item'); });
  };

  function updateBadge(count) {
    if (!cartBadge) return;
    cartBadge.textContent = count;
    cartBadge.style.display = count > 0 ? 'flex' : 'none';
  }

  function bounceCart() {
    var wrap = $('#cartWrap');
    if (!wrap) return;
    wrap.classList.remove('bounce');
    void wrap.offsetWidth;
    wrap.classList.add('bounce');
  }

  /* ---------- TOAST ---------- */
  var toastTimer;
  window.showToast = function (msg) {
    var t = $('#toast');
    if (!t) return;
    clearTimeout(toastTimer);
    t.textContent = msg;
    t.classList.add('show');
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2800);
  };

  /* ---------- REVEAL ON SCROLL ---------- */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vi', 'vis');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    $$('.rv').forEach(function (el) { observer.observe(el); });
  } else {
    $$('.rv').forEach(function (el) { el.classList.add('vi', 'vis'); });
  }

  /* ---------- FOCUS TRAPPING ---------- */
  var trapContainer = null;
  var trapHandler = null;

  function trapFocus(container) {
    releaseFocus();
    trapContainer = container;
    trapHandler = function (e) {
      if (e.key !== 'Tab') return;
      var focusable = $$('a[href],button:not([disabled]),input:not([disabled]),textarea:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])', container)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    document.addEventListener('keydown', trapHandler);
  }

  function releaseFocus() {
    if (trapHandler) {
      document.removeEventListener('keydown', trapHandler);
      trapHandler = null;
      trapContainer = null;
    }
  }

  /* ---------- EMAIL OBFUSCATION ---------- */
  $$('.js-email').forEach(function (el) {
    var u = 'hello', d = 'shopspecta.com';
    el.href = 'mailto:' + u + '@' + d;
    el.textContent = u + '@' + d;
  });

  /* ---------- HELPERS ---------- */
  function formatMoney(cents) {
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency', currency: 'EUR', minimumFractionDigits: 2
    }).format(cents / 100);
  }

  function escHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  /* ---------- FAQ ACCORDION ---------- */
  window.toggleFaq = function (el) {
    var wasOpen = el.classList.contains('open');
    $$('.fqi').forEach(function (item) { item.classList.remove('open'); });
    if (!wasOpen) el.classList.add('open');
  };

  /* ---------- STATS COUNTER ANIMATION ---------- */
  var counters = $$('.stn[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var counterObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseInt(el.getAttribute('data-count'), 10);
        var suffix = el.getAttribute('data-suffix') || '';
        var prefix = el.getAttribute('data-prefix') || '';
        var duration = 1600;
        var start = performance.now();
        function step(now) {
          var progress = Math.min((now - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var current = Math.round(eased * target);
          el.textContent = prefix + current + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        counterObs.unobserve(el);
      });
    }, { threshold: 0.3 });
    counters.forEach(function (el) { counterObs.observe(el); });
  }

  /* ---------- TICKER TRACK ---------- */
  var tickerTrack = $('#tickerTrack');
  if (tickerTrack && !tickerTrack.children.length) {
    var phrases = ['Simply Spectacular', 'Designed in Enschede', 'Minimal Design', 'RFID Protected'];
    var tickerHTML = '';
    for (var t = 0; t < 2; t++) {
      phrases.forEach(function (p) { tickerHTML += '<span>' + p + '</span>'; });
    }
    tickerTrack.innerHTML = tickerHTML;
  }

  /* ---------- LOGO MARQUEE ---------- */
  var lmTrack = $('#lmTrack');
  if (lmTrack && !lmTrack.children.length && window.ASSET_URLS) {
    var logos = [
      window.ASSET_URLS.logoPrimaryLight,
      window.ASSET_URLS.logoLight,
      window.ASSET_URLS.logomarkLight
    ].filter(Boolean);
    if (logos.length) {
      var marqueeHTML = '';
      for (var m = 0; m < 6; m++) {
        logos.forEach(function (src) { marqueeHTML += '<img src="' + src + '" alt="Specta" loading="lazy">'; });
      }
      lmTrack.innerHTML = marqueeHTML;
    }
  }

  /* ---------- INITIAL CART BADGE ---------- */
  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) { updateBadge(cart.item_count); })
    .catch(function () {});

})();
